export { }

declare global {
	interface Object {
		deepCopy: <T>(object: T) => T;
	}
}

Object.deepCopy = function <T>(object: T): T {
	return copyObject(object);

	function copyObject(obj: any, objectRef?: Map<Object, Object>): any {

		if (!obj || typeof obj !== 'object') return obj;
		if (!objectRef) objectRef = new Map<Object, Object>();

		if (objectRef.has(obj)) return objectRef.get(obj);

		if (obj instanceof Date) {
			const date = new Date();
			date.setTime(obj.getTime());
			return date;
		}

		if (obj instanceof Array) {
			const array = [];
			for (let i = 0; i < obj.length; i++) {
				array[i] = copyObject(obj[i], objectRef);
			}
			return array;
		}

		if (obj instanceof Object) {
			const copy: any = {};
			objectRef.set(obj, copy);
			if (Object.getPrototypeOf(obj)) Object.setPrototypeOf(copy, Object.getPrototypeOf(obj));
			for (let attribute in obj) {
				if (obj.hasOwnProperty(attribute)) copy[attribute] = copyObject(obj[attribute], objectRef);
			}
			return copy;
		}
		return obj;
	}
}

